import { useMemo } from 'react';
import { useMutation } from 'react-query';
// react-query ships MutationOptions as a type only — it has no runtime export.
import type { MutationOptions } from 'react-query';
import ProspectProfileService from '../../services/prospectProfileService';

const useConvertProspectToApplicantMutation = ({
  organizationId,
  propertyId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  options: MutationOptions,
}) => {
  const prospectProfileService = useMemo(
    () => new ProspectProfileService(),
    [],
  );

  return useMutation(
    ({ prospectId, payload }) =>
      prospectProfileService.convertToApplicant(
        organizationId,
        propertyId,
        prospectId,
        payload,
      ),
    options,
  );
};

export default useConvertProspectToApplicantMutation;
